import type { FC } from 'react';
import React from 'react';
import { createFeature, Desktop, Mobile } from '@edreamsodigeo/frontend-core';
import type { ResponsiveSpaces } from '@edreamsodigeo/prisma-design-system/esm/themes/cobalt/types';
import { Box, Col } from '@edreamsodigeo/prisma-design-system';

import { SIDEBAR_PAX_STICKY_META } from '@/versionedComponents';

export interface CheckoutPageMainContentProps {
  noPadding?: boolean;
}
interface DesktopMainContentProps {
  children: React.ReactNode;
  pt?: ResponsiveSpaces;
}

const CheckoutPageMainContentMobile: FC<CheckoutPageMainContentProps> = ({
  noPadding = false,
  children,
}) => (
  <Box
    pl={noPadding ? '0' : { _: 'big', md: '0' }}
    pr={noPadding ? '0' : { _: 'big', md: '2x_big' }}
    minWidth="100%"
  >
    {children}
  </Box>
);

const DesktopMainContent: FC<DesktopMainContentProps> = ({ children, pt }) => (
  <Col
    minWidth="600px"
    width={{
      _: '600px',
      md: '835px',
    }}
  >
    <Box
      pl={{ _: 'big', md: '0' }}
      pr={{ _: 'big', md: '2x_big' }}
      {...(pt && { pt })}
    >
      {children}
    </Box>
  </Col>
);

const CheckoutPageMainContentDesktop: FC = ({ children }) => (
  <DesktopMainContent>{children}</DesktopMainContent>
);

const CheckoutPageMainContentVersionedDesktop: FC = ({ children }) => (
  <DesktopMainContent pt="small">{children}</DesktopMainContent>
);

const CheckoutPageMainContenDesktop = createFeature({
  name: SIDEBAR_PAX_STICKY_META,
  variations: [
    CheckoutPageMainContentDesktop,
    CheckoutPageMainContentVersionedDesktop,
  ],
  version: 1,
});

const CheckoutPageMainContent: FC<CheckoutPageMainContentProps> = ({
  noPadding = false,
  children,
}) => (
  <>
    <Mobile>
      <CheckoutPageMainContentMobile noPadding={noPadding}>
        {children}
      </CheckoutPageMainContentMobile>
    </Mobile>
    <Desktop>
      <CheckoutPageMainContenDesktop>{children}</CheckoutPageMainContenDesktop>
    </Desktop>
  </>
);

export default CheckoutPageMainContent;
